{
  "Invalid date": "Invalid date",
  "Start date is required": "Start date is required",
  "End date is required": "End date is required",
  "Name is required": "Name is required",
  "Name": "Name",
  "Method": "Method",
  "Select a method": "Select a method",
  "open-ended": "Open-ended",
  "self-paced": "Self-paced",
  "scheduled": "Scheduled",
  "Date": "Date",
  "Start date": "Start date",
  "End date": "End date",
  "Location": "Location",
  "Save new variant": "Save new variant",
  "Save variant": "Save variant",
  "no-variants-warning": "Variants can only be added to existing courses. When your new course is created you can enter edit-page and add variants.",
  "Stop editing": "Stop editing",
  "Edit variant": "Edit variant",
  "Remove variant": "Remove variant",
  "Add variant": "Add variant",
  "Enabled variant": "Enabled variant"
}
